/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkyouremail2Inputs */

const en_checkyouremail2 = /** @type {(inputs: Checkyouremail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check Your Email`)
};

const de_checkyouremail2 = /** @type {(inputs: Checkyouremail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schau in dein Postfach`)
};

/**
* | output |
* | --- |
* | "Check Your Email" |
*
* @param {Checkyouremail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkyouremail2 = /** @type {((inputs?: Checkyouremail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkyouremail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkyouremail2(inputs)
	return de_checkyouremail2(inputs)
});
export { checkyouremail2 as "checkYourEmail" }